import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';

import { AuthenticationApiService } from '@magicore/core';
import { environment } from 'src/environments/environment';
import { User } from '../models/user.model';
import { UserLoginData } from 'src/app/auth/store/session/session.state';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private authenticationApiService: AuthenticationApiService, private httpClient: HttpClient) {}

  login(data: UserLoginData): Observable<any> {
    // TO FIX (magicore): AuthenticationApiService.login is declared to return void, but it returns User
    return this.authenticationApiService.login(data.Email, data.Password, data.RememberMe).pipe(
      take(1),
      map(user => {
        return user;
      })
    );
  }

  getUser(): Observable<User> {
    // TO FIX (magicore): there is no method AuthenticationApiService.getUser
    return this.httpClient.get(`${environment.apiUrl}/Core/Auth`).pipe(
      take(1),
      map((user: User) => {
        return user;
      })
    );
  }

  logout() {
    // TO FIX (magicore): if this should be handled using AuthenticationApiService.logout
    return this.httpClient.post(`${environment.apiUrl}/Core/Auth/Logout`, null).pipe(
      map(() => {
        return of('');
      }),
      // If user is already logged out, logout operation should still continue (state set to empty, redirect to login)
      catchError(() => {
        return of('');
      })
    );
  }

  /**
   * Send a password recovery email
   * @param email The email of the user
   */
  sendPasswordRecoverEmail(email: string): Observable<boolean> {
    return this.httpClient.post(`${environment.apiUrl}/Core/Auth/Password/Recover`, { Email: email }).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  /**
   * Reset user password with password reset token
   * @param email User email
   * @param newPassword New password
   * @param token Password reset token
   */
  resetPassword(email: string, newPassword: string, token: string): Observable<boolean> {
    return this.httpClient
      .post(`${environment.apiUrl}/Core/Auth/Password/Reset`, {
        Email: email,
        Token: token,
        Password: newPassword,
        ConfirmPassword: newPassword // MagiCAD Core wants the confirmation here too, so we have to send it
      })
      .pipe(
        map(() => true),
        catchError(() => of(false))
      );
  }
}
